import { render, staticRenderFns } from "./EditBrand.vue?vue&type=template&id=1a324cb2"
import script from "./EditBrand.vue?vue&type=script&lang=js"
export * from "./EditBrand.vue?vue&type=script&lang=js"
import style0 from "./EditBrand.vue?vue&type=style&index=0&id=1a324cb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports